// extracted by mini-css-extract-plugin
module.exports = {"authNavigation":"authNavigation_authNavigation__1kYZu","authNavigation__link":"authNavigation_authNavigation__link__2mv9P"};